// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomDatePicker_container__3pCOC","calendar":"CustomDatePicker_calendar__25boi"};